// Lazy loading for code splitting

const Home = () => import("@/components/Home.vue");
const MainLayout = () => import("@/layouts/MainLayout.vue");
const AuthCallback = () => import("@/views/authCallback.vue");
const LoginError = () => import("@/views/loginError.vue");
const NotFound = () => import("@/views/notFound.vue");
const UserAdmin = () => import("@/views/userAdmin.vue");
const Login = () => import("@/views/userLogin.vue");
const UserProfile = () => import("@/views/userProfile.vue");

const routes = [
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: { requiresAuth: false },
  },
  {
    path: "/auth-callback",
    name: "AuthCallback",
    component: AuthCallback,
    meta: { requiresAuth: false },
  },
  {
    path: "/login-error",
    name: "LoginError",
    component: LoginError,
    meta: { requiresAuth: false },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: NotFound,
    meta: { requiresAuth: false },
  },
  {
    path: "/",
    component: MainLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: "",
        name: "Home",
        component: Home,
      },
      {
        path: "profile",
        name: "UserProfile",
        component: UserProfile,
      },
      {
        path: "admin",
        name: "UserAdmin",
        component: UserAdmin,
        meta: { requiresAdmin: true },
      },
    ],
  },
];

export default routes;
